import { useSelector } from 'react-redux';

interface MenuItem {
  name?: string;
  permissions?: {
    is_create?: boolean;
  };
}

interface MenuState {
  items?: MenuItem[] | null;
}

/**
 * Hook to check if the current user has shipment creation permissions.
 * Returns false for "ZoomLogi Support" company regardless of permissions.
 *
 * @param companyName - Optional company name to check against
 * @returns Boolean indicating if user can create shipments
 */
export const useShipmentPermission = (companyName?: string): boolean => {
  const mainMenu = useSelector(
    (state: { menu: MenuState }) => state.menu.items
  );

  const shipmentPermissions = mainMenu?.find(
    (item) => item?.name?.toLowerCase() === 'shipment'
  )?.permissions;

  const hasCreate = !!shipmentPermissions?.is_create;
  if (!companyName) return hasCreate;
  if (companyName?.trim()?.toLowerCase() === 'zoomlogi support') {
    return false;
  }
  return hasCreate;
};
